import { useSyncExternalStore } from 'react';

function subscribe(query: string, onChange: () => void): () => void {
  const mql = window.matchMedia(query);
  mql.addEventListener('change', onChange);
  return () => {
    mql.removeEventListener('change', onChange);
  };
}

/** Tracks whether `query` currently matches, updating live as the viewport
 *  changes. Built on `useSyncExternalStore` so the browser's `matchMedia`
 *  state is the single source of truth — no local state to fall out of sync. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => subscribe(query, onChange),
    () => window.matchMedia(query).matches,
  );
}
